import React from 'react'
import { FaMailBulk } from "react-icons/fa"

const EMAIL = "nathaniel.asia@alumni.duke.edu";

const Footer = () => {
  return (
    <section className="border-t border-ink-800 py-12" id="footer">
      <a
        href={`mailto:${EMAIL}`}
        className="group mx-auto flex max-w-2xl flex-col items-center gap-1 px-6 pb-1 text-center font-mono text-mist-100"
      >
        {/* Mobile: stacked, only the CTA phrase underlines (the email below
            is supporting detail on its own line, not a second underlined
            thing). Desktop: everything sits on one visual line, so the
            underline covers the whole line as a single unit instead of
            trailing off after "Let's chat!". Two variants, not one
            responsive mashup: the underline math (what element's box the
            underline sizes itself to) genuinely differs between "CTA alone"
            and "CTA + email together", so forcing one markup to cover both
            keeps re-breaking on a redesign. */}
        <span className="flex items-center gap-2 text-lg sm:hidden">
          <FaMailBulk size={20} className="text-signal-400" />
          <span className="hover-underline">Let's chat!</span>
        </span>
        <span className="text-sm text-mist-500 sm:hidden">{EMAIL}</span>

        <span className="hidden items-center gap-2 text-lg sm:flex">
          <FaMailBulk size={20} className="text-signal-400" />
          <span className="hover-underline">Let's chat! {EMAIL}</span>
        </span>
      </a>
    </section>
  )
}

export default Footer
